// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1YDw0","content":"LoadingAlert_content__2uzFq"};